import { Dropdown } from 'antd'
import { useRouter } from 'next/router'
import { useCallback, useMemo } from 'react'
import { MyIcon } from '~/components/ui/MyIcon'
import {
  PostSortField,
  getVisibleList_squareModule_postVisibleTypeList,
} from '~/graphqls/types'
import styles from '../home/Sort.module.css'
import classNames from 'classnames'

export const PlazaSort: React.FC<{
  sizes: { name: string }[]
  visibleTypeList: getVisibleList_squareModule_postVisibleTypeList[]
  models: { name: string; ids: string[] }[]
  styleModels: { key: string; name: string }[]
}> = ({ sizes, visibleTypeList, models, styleModels }) => {
  const router = useRouter()

  const sortMenu = [
    {
      key: PostSortField.CREATE_TIME,
      label: '最新发布',
    },
    {
      key: PostSortField.SAME_COUNT,
      label: '同款最多',
    },
    {
      key: PostSortField.LIKE_COUNT,
      label: '点赞最多',
    },
    {
      key: PostSortField.COLLECT_COUNT,
      label: '收藏最多',
    },
  ]
  const initImageMenu = [
    {
      label: '不限',
      key: '',
    },
    {
      label: '有',
      key: '1',
    },
    {
      label: '无',
      key: '0',
    },
  ]
  const characterMenu = initImageMenu
  const modelFusionMenu = initImageMenu

  const visibleTypeMenu = [
    {
      key: '',
      label: '不限',
    },
    ...visibleTypeList
      ?.filter(item => item.value !== '-1' && item.value !== '2')
      ?.map(it => {
        return {
          key: it?.value || '',
          label: it?.desc || '',
        }
      }),
  ]
  const sizeMenu = [
    {
      key: '',
      label: '全部',
    },
    ...sizes.map(it => {
      return {
        key: it.name,
        label: it.name,
      }
    }),
  ]
  const modelMenu = [
    {
      key: '',
      label: '全部',
    },
    ...models.map(it => {
      return {
        key: it.ids.join(','),
        label: it.name,
      }
    }),
  ]

  const styleModelMenu = [
    {
      key: '',
      label: '全部',
    },
    ...styleModels.map(it => {
      return {
        key: it.key,
        label: it.name,
      }
    }),
  ]

  const selectSort = useMemo(() => {
    return router.query.sort || PostSortField.CREATE_TIME
  }, [router.query.sort])

  const selectSize = useMemo(() => {
    return router.query.size || ''
  }, [router.query.size])

  const selectModel = useMemo(() => {
    return router.query.model || ''
  }, [router.query.model])

  const selectStyleModelKey = useMemo(() => {
    return router.query.styleModelKey || ''
  }, [router.query.styleModelKey])

  const selectInitImage = useMemo(() => {
    return router.query.initImage || ''
  }, [router.query.initImage])

  const selectCharacter = useMemo(
    () => router.query.character || '',
    [router.query.character]
  )

  const selectModelFusion = useMemo(
    () => router.query.modelFusion || '',
    [router.query.modelFusion]
  )

  const selectVisibleType = useMemo(() => {
    return router.query.visibleType || ''
  }, [router.query.visibleType])

  const jumpTo = useCallback(
    (query: any) => {
      router.replace({
        pathname: router.pathname,
        query,
      })
    },
    [router]
  )

  return (
    <div className="flex justify-start items-center mb-4">
      <Dropdown
        placement="bottomLeft"
        overlayClassName={styles.dropdown}
        menu={{
          items: sortMenu,
          selectedKeys: [selectSort as string],
          onClick: item => {
            jumpTo({
              ...router.query,
              sort: item.key,
            })
          },
        }}
      >
        <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer">
          排序：{sortMenu.find(item => item.key === selectSort)?.label}{' '}
          <MyIcon icon="arrow-down-simple"></MyIcon>
        </div>
      </Dropdown>
      <Dropdown
        placement="bottomLeft"
        overlayClassName={styles.dropdown}
        menu={{
          items: sizeMenu,
          selectedKeys: [selectSize as string],
          onClick: item => {
            if (item.key) {
              jumpTo({
                ...router.query,
                size: item.key,
              })
            } else {
              delete router.query.size
              jumpTo(router.query)
            }
          },
        }}
      >
        <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer ml-4">
          画面尺寸 ：{sizeMenu.find(item => item.key === selectSize)?.label}{' '}
          <MyIcon icon="arrow-down-simple"></MyIcon>
        </div>
      </Dropdown>
      <Dropdown
        placement="bottomLeft"
        overlayClassName={classNames(styles.dropdown, {
          [styles.horizontal]: true,
        })}
        menu={{
          items: modelMenu,
          selectedKeys: [selectModel as string],
          onClick: item => {
            if (item.key) {
              jumpTo({
                ...router.query,
                model: item.key,
              })
            } else {
              delete router.query.model
              jumpTo(router.query)
            }
          },
        }}
      >
        <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer ml-4">
          模型选择：
          {modelMenu.find(item => item.key === selectModel)?.label}{' '}
          <MyIcon icon="arrow-down-simple"></MyIcon>
        </div>
      </Dropdown>
      <Dropdown
        placement="bottomLeft"
        overlayClassName={classNames(styles.dropdown, {
          [styles.horizontal]: true,
        })}
        menu={{
          items: styleModelMenu,
          selectedKeys: [selectStyleModelKey as string],
          onClick: item => {
            if (item.key) {
              jumpTo({
                ...router.query,
                styleModelKey: item.key,
              })
            } else {
              delete router.query.styleModelKey
              jumpTo(router.query)
            }
          },
        }}
      >
        <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer ml-4">
          风格模型：
          {
            styleModelMenu.find(item => item.key === selectStyleModelKey)?.label
          }{' '}
          <MyIcon icon="arrow-down-simple"></MyIcon>
        </div>
      </Dropdown>
      <Dropdown
        placement="bottomLeft"
        overlayClassName={styles.dropdown}
        menu={{
          items: initImageMenu,
          selectedKeys: [selectInitImage as string],
          onClick: item => {
            if (item.key) {
              jumpTo({
                ...router.query,
                initImage: item.key,
              })
            } else {
              delete router.query.initImage
              jumpTo(router.query)
            }
          },
        }}
      >
        <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer ml-4">
          参考图：
          {initImageMenu.find(item => item.key === selectInitImage)?.label}{' '}
          <MyIcon icon="arrow-down-simple"></MyIcon>
        </div>
      </Dropdown>

      <Dropdown
        placement="bottomLeft"
        overlayClassName={styles.dropdown}
        menu={{
          items: characterMenu,
          selectedKeys: [selectCharacter as string],
          onClick: item => {
            if (item.key) {
              jumpTo({
                ...router.query,
                character: item.key,
              })
            } else {
              delete router.query.character
              jumpTo(router.query)
            }
          },
        }}
      >
        <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer ml-4">
          角色同人：
          {characterMenu.find(item => item.key === selectCharacter)?.label}{' '}
          <MyIcon icon="arrow-down-simple"></MyIcon>
        </div>
      </Dropdown>

      <Dropdown
        placement="bottomLeft"
        overlayClassName={styles.dropdown}
        menu={{
          items: modelFusionMenu,
          selectedKeys: [selectModelFusion as string],
          onClick: item => {
            if (item.key) {
              jumpTo({
                ...router.query,
                modelFusion: item.key,
              })
            } else {
              delete router.query.modelFusion
              jumpTo(router.query)
            }
          },
        }}
      >
        <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer ml-4">
          融合模型：
          {
            modelFusionMenu.find(item => item.key === selectModelFusion)?.label
          }{' '}
          <MyIcon icon="arrow-down-simple"></MyIcon>
        </div>
      </Dropdown>

      <Dropdown
        placement="bottomLeft"
        overlayClassName={styles.dropdown}
        menu={{
          items: visibleTypeMenu,
          selectedKeys: [selectVisibleType as string],
          onClick: item => {
            if (item.key) {
              jumpTo({
                ...router.query,
                visibleType: item.key,
              })
            } else {
              delete router.query.visibleType
              jumpTo(router.query)
            }
          },
        }}
      >
        <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer ml-4">
          公开范围：
          {
            visibleTypeMenu.find(item => item.key === selectVisibleType)?.label
          }{' '}
          <MyIcon icon="arrow-down-simple"></MyIcon>
        </div>
      </Dropdown>
    </div>
  )
}
